
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { usePrincipalProjetosViewModel } from "../../viewModels/principal_projetos_view_model";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import RefreshButton from "../../../../../common/components/refresh_button";
import AlertError from "../../../../../common/components/alert_error";
import StatCard from "../../../../../common/components/statCard";
import PrincipaisDocGrid from "../../../../../common/components/principaisDocGrid";


/**
 * PrincipalProjetos
 */

export const PrincipalProjetos = () => {

    const viewModel = usePrincipalProjetosViewModel();

    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <></>
                        // <div className="flex flex-row gap-2">
                        //     <div className="w-[10rem]">
                        //         <PrimaryButton
                        //             buttonColor="yellow"
                        //             onClick={viewModel.handleRelatorio}>
                        //             Gerar relatório
                        //         </PrimaryButton>
                        //     </div>
                        // </div>
                    }
                />
            </PageTopBar>

            {/**
        * Page
        */}

            <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Projetos
                    </Link>
                    <Typography className="text-primary-green">
                        Principal Projetos
                    </Typography>
                </Breadcrumbs>

                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Principal Projetos </h1>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>

                    <div className="w-full justify-end flex gap-2"></div>
                </div>
                {
                    viewModel.errorMessage !== undefined
                        ? (
                            <div className="w-full">
                                <AlertError
                                    messageErro={viewModel.errorMessage}
                                    onTryAgain={viewModel.handleReload} />
                            </div>
                        ) : (
                            <>
                                {
                                    viewModel.dashboardProjetosInformation !== null && (
                                        <div className="w-full flex flex-col gap-4 mb-8">

                                            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                                                <StatCard
                                                    title='Projetos Atrasados'
                                                    value={viewModel.dashboardProjetosInformation.projetosAtrasados}
                                                    icon={"symbol"}
                                                    colorClass={{
                                                        bg: 'bg-red-500',
                                                        text: 'text-white',
                                                        bgHover: 'bg-red-600',
                                                    }}
                                                    linkText='Ver detalhes'
                                                    onClick={() => viewModel.handleCardClick(viewModel.cardIds.projetosAtrasados)}
                                                />

                                                <StatCard
                                                    title='Disciplinas Atrasadas'
                                                    value={viewModel.dashboardProjetosInformation.disciplinasAtrasadas}
                                                    icon={"symbol"}
                                                    colorClass={{
                                                        bg: 'bg-yellow-500',
                                                        text: 'text-white',
                                                        bgHover: 'bg-yellow-600',
                                                    }}
                                                    linkText='Ver detalhes'
                                                    onClick={() => viewModel.handleCardClick(viewModel.cardIds.disciplinasAtrasadas)}
                                                />

                                                <StatCard
                                                    title='Subdisciplinas Atrasadas'
                                                    value={viewModel.dashboardProjetosInformation.subdisciplinasAtrasadas}
                                                    icon={"symbol"}
                                                    colorClass={{
                                                        bg: 'bg-blue-500',
                                                        text: 'text-white',
                                                        bgHover: 'bg-blue-600',
                                                    }}
                                                    linkText='Ver detalhes'
                                                    onClick={() => viewModel.handleCardClick(viewModel.cardIds.subdisciplinasAtrasadas)}
                                                />
                                            </div>
                                            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                                                <StatCard
                                                    title='Impressões Pendentes'
                                                    value={viewModel.dashboardProjetosInformation.impressoesPendentes}
                                                    icon={"symbol"}
                                                    colorClass={{
                                                        bg: 'bg-yellow-500',
                                                        text: 'text-white',
                                                        bgHover: 'bg-yellow-600',
                                                    }}
                                                    linkText='Ver detalhes'
                                                    onClick={() => viewModel.handleCardClick(viewModel.cardIds.impressoesPendentes)}
                                                />

                                                <StatCard
                                                    title='Impressões Aprovadas'
                                                    value={viewModel.dashboardProjetosInformation.impressoesAprovadas}
                                                    icon={"symbol"}
                                                    colorClass={{
                                                        bg: 'bg-green-500',
                                                        text: 'text-white',
                                                        bgHover: 'bg-green-600',
                                                    }}
                                                    linkText='Ver detalhes'
                                                    onClick={() => viewModel.handleCardClick(viewModel.cardIds.impressoesAprovadas)}
                                                />

                                                <StatCard
                                                    title='Impressões Reprovadas'
                                                    value={viewModel.dashboardProjetosInformation.impressoesReprovadas}
                                                    icon={"symbol"}
                                                    colorClass={{
                                                        bg: 'bg-red-500',
                                                        text: 'text-white',
                                                        bgHover: 'bg-red-600',
                                                    }}
                                                    linkText='Ver detalhes'
                                                    onClick={() => viewModel.handleCardClick(viewModel.cardIds.impressoesReprovadas)}
                                                />
                                            </div>

                                            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                                                <StatCard
                                                    title='Revisão Em Aberto'
                                                    value={viewModel.dashboardProjetosInformation.revisoesEmAberto}
                                                    icon={"symbol"}
                                                    colorClass={{
                                                        bg: 'bg-gray-500',
                                                        text: 'text-white',
                                                        bgHover: 'bg-gray-600',
                                                    }}
                                                    linkText='Ver detalhes'
                                                    onClick={() => viewModel.handleCardClick(viewModel.cardIds.revisoesEmAberto)}
                                                />

                                                <StatCard
                                                    title='Revisao Em Análise'
                                                    value={viewModel.dashboardProjetosInformation.revisoesEmAnalise}
                                                    icon={"symbol"}
                                                    colorClass={{
                                                        bg: 'bg-yellow-500',
                                                        text: 'text-white',
                                                        bgHover: 'bg-yellow-600',
                                                    }}
                                                    linkText='Ver detalhes'
                                                    onClick={() => viewModel.handleCardClick(viewModel.cardIds.revisoesEmAnalise)}
                                                />
                                                <StatCard
                                                    title='Revisões Encerradas'
                                                    value={viewModel.dashboardProjetosInformation.revisoesEncerradas}
                                                    icon={"symbol"}
                                                    colorClass={{
                                                        bg: 'bg-green-500',
                                                        text: 'text-white',
                                                        bgHover: 'bg-green-600',
                                                    }}
                                                    linkText='Ver detalhes'
                                                    onClick={() => viewModel.handleCardClick(viewModel.cardIds.revisoesEncerradas)}
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                            </>
                        )
                }
            </div>

            <PrincipaisDocGrid
                loading={viewModel.loading}
                rows={viewModel.docLista}
                totalItems={viewModel.pagination.totalItems}
                page={viewModel.pagination.page}
                rowsPerPage={viewModel.pagination.rowsPerPage}
                onPageChange={(p) => viewModel.handlePageChange(p)}
                onRowsPerPageChange={(p) => viewModel.handleRowsPerPageChange(p)}
                onActionExportar={(IdArquivoModulo, NomeArquivo) => viewModel.handleDownloadFile(IdArquivoModulo, NomeArquivo)}
            />

        </>
    );
}
